import { createTheme } from "@mui/material/styles";

// Paleta alineada al logo Novasis Pay: navy + teal.
export const brand = {
  navy: "#14315B",
  navyDeep: "#0E2038",
  teal: "#0F7D93",
  tealSoft: "#159AB4",
  textOnDark: "#E5E7EB",
  textMutedOnDark: "#94A3B8",
};

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: brand.teal, dark: "#0B5F70", contrastText: "#FFFFFF" },
    secondary: { main: brand.navy },
    background: { default: "#F1F5F9", paper: "#FFFFFF" },
    success: { main: "#16A34A" },
    warning: { main: "#D97706" },
    error: { main: "#DC2626" },
    text: { primary: "#0F172A", secondary: "#475569" },
  },
  shape: { borderRadius: 14 },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "'Segoe UI'",
      "Roboto",
      "'Helvetica Neue'",
      "Arial",
      "sans-serif",
    ].join(","),
    h4: { fontWeight: 700, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: "none" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 10, paddingInline: 18 },
        containedPrimary: {
          background: `linear-gradient(135deg, ${brand.teal} 0%, ${brand.tealSoft} 100%)`,
          "&:hover": {
            background: `linear-gradient(135deg, #0B5F70 0%, ${brand.teal} 100%)`,
          },
        },
      },
    },
    MuiTextField: { defaultProps: { size: "small", fullWidth: true } },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});
